import { Button, Col, Form, Input, Row, Section } from 'ui';

type ForgotPasswordFormValues = {
  email: string;
};

type P = {
  email?: string;
  loading: boolean;
  onNavigateToPrimaryLogin: () => Promise<void>;
  onSubmit: (data: ForgotPasswordFormValues) => void;
};

const ForgotPasswordForm = ({ email, loading, onNavigateToPrimaryLogin, onSubmit }: P) => {
  const [form] = Form.useForm();

  const onFinish = (data: ForgotPasswordFormValues) => {
    onSubmit(data);
  };

  return (
    <Form<ForgotPasswordFormValues>
      className="forgot-password-form"
      form={form}
      initialValues={{ email }}
      onFinish={onFinish}
    >
      <Form.Item<ForgotPasswordFormValues>
        label="Email"
        name="email"
        rules={[
          {
            type: 'email',
          },
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input autoComplete="email" />
      </Form.Item>
      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button block htmlType="submit" loading={loading} type="primary">
              Send reset link
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              onClick={async () => {
                await onNavigateToPrimaryLogin();
              }}
            >
              Back to Log in
            </Button>
          </Col>
        </Row>
      </Section>
    </Form>
  );
};

export default ForgotPasswordForm;
